<template>
  <div>
    <!-- Desktop Filters -->
    <warehouse-filters-desktop
      v-if="!device.isMobile"
      :active-tab="activeTab"
      :warehouses="warehouses"
      :selected-warehouses="selectedWarehouses"
      :selected-suppliers="selectedSuppliers"
      :suppliers="suppliers"
      :filters="filters"
      :dates="dates"
      :code-filter-groceries="codeFilterGroceries"
      :shifts="shifts"
      @update:selectedWarehouses="$emit('update:selectedWarehouses', $event)"
      @update:selectedSuppliers="$emit('update:selectedSuppliers', $event)"
      @update:dates="$emit('update:dates', $event)"
      @update:filter="$emit('update:filter', $event)"
      @toggle-warehouses="$emit('toggle-warehouses')"
      @toggle-suppliers="$emit('toggle-suppliers')"
      @refresh="$emit('refresh')"
    />

    <!-- Mobile Filters -->
    <warehouse-filters-mobile
      v-if="device.isMobile"
      :active-tab="activeTab"
      :warehouses="warehouses"
      :selected-warehouses="selectedWarehouses"
      :selected-suppliers="selectedSuppliers"
      :suppliers="suppliers"
      :filters="filters"
      :dates="dates"
      :code-filter-groceries="codeFilterGroceries"
      :shifts="shifts"
      @update:selectedWarehouses="$emit('update:selectedWarehouses', $event)"
      @update:selectedSuppliers="$emit('update:selectedSuppliers', $event)"
      @update:dates="$emit('update:dates', $event)"
      @update:filter="$emit('update:filter', $event)"
      @toggle-warehouses="$emit('toggle-warehouses')"
      @toggle-suppliers="$emit('toggle-suppliers')"
      @reset="$emit('reset')"
      @apply="$emit('apply')"
    />
  </div>
</template>

<script>
import WarehouseFiltersDesktop from "./WarehouseFiltersDesktop.vue";
import WarehouseFiltersMobile from "./WarehouseFiltersMobile.vue";

export default {
  name: "WarehouseFilters",
  components: {
    WarehouseFiltersDesktop,
    WarehouseFiltersMobile,
  },
  props: {
    activeTab: {
      type: Object,
      default: null,
    },
    warehouses: {
      type: Array,
      default: () => [],
    },
    selectedWarehouses: {
      type: Array,
      default: () => [],
    },
    selectedSuppliers: {
      type: Array,
      default: () => [],
    },
    suppliers: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      required: true,
    },
    dates: {
      type: Array,
      default: () => [],
    },
    codeFilterGroceries: {
      type: Array,
      default: () => [],
    },
    shifts: {
      type: Array,
      default: () => [1, 2, 3, 4],
    },
  },
};
</script>
